module.exports = __webpack_public_path__ + "img/IMG-20200718-WA0007.05b71e60.jpg";